import { addMonths } from "date-fns";
import { useState } from "react";

type UseBirthdaysPageReturn = {
    monthOffset: number;
    setMonthOffset: (offset: number) => void;
    /** addMonths(new Date(), monthOffset) */
    viewDate: Date;
    viewYear: number;
    /** 0-indexed, ready for groupBirthdays */
    viewMonth: number;
};

/**
 * Owns the month-navigation state for the Birthdays page.
 * It deliberately does not fetch members or group birthdays - the component owns
 * data fetching (useMembers) and calls groupBirthdays in render, keeping the
 * grouping logic in a single place.
 */
export function useBirthdaysPage(): UseBirthdaysPageReturn {
    const [monthOffset, setMonthOffset] = useState(0);

    const viewDate = addMonths(new Date(), monthOffset);

    return {
        monthOffset,
        setMonthOffset,
        viewDate,
        viewMonth: viewDate.getMonth(),
        viewYear: viewDate.getFullYear(),
    };
}
